namespace TotalPoll {
    // @ts-ignore
    import Service = TotalCore.Common.Service;

    @Service('services.totalpoll')
    // @ts-ignore
    export class Repository {

        private resource;

        constructor($resource, private prefix, private ajaxEndpoint) {
            this.resource = $resource(ajaxEndpoint, {}, {
                list: {method: 'GET', cache: true, isArray: true},
                apply: {method: 'POST'}
            });

            return this;
        }

        getPolls(page:number = 1) {
            return this.resource.list({action: 'totalpoll_presets_polls', page: page}).$promise;
        }

        applyPreset(poll:number, preset:number) {
            return this.resource.apply({action: 'totalpoll_apply_preset', poll: poll, preset: preset}).$promise;
        }
    }
}
